interface IError {
  message: string;
  reasons: string[];
}

export class ProblemDetails {
  status: number;
  title: string;
  detail: string;
  extensions: { [key: string]: any };

  constructor(status: number, title: string, detail: string, errors: object) {
    this.status = status;
    this.title = title;
    this.detail = detail;

    if (errors) {
      this.extensions = {
        errors: errors,
      };
    }
  }
}
